import React from "react";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {Box, Drawer, Grid, ListItem, ListItemButton, ListItemText, Typography} from "@mui/material";
import DayDrawer from "./DayDrawer";
import {getCalendar} from "../../api/client";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Calendar(props) {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState([]);
  const ref = React.useRef();
  const wdArr = ["日", "月", "火", "水", "木", "金", "土"];
  const scrollToSelect = () => {
    if (!Boolean(props.state.stopRender)) {
      ref.current.scrollIntoView({block: "center", behavior: "smooth"})
    };
  };
  const setCalendarBody = () => {
    const calendar = [];
    for(let day = moment(props.state.date).startOf("month").format(); day <= moment(props.state.date).endOf("month").format(); day = moment(day).add(1, "d").format()) {
      let color = "rgba(0, 0, 0, 0.23)";
      if (moment(day).format("d") === "0" || props.state.data[moment(day).format("D")].hdFg) {
        color = "rgba(232, 122, 144, 1.0)";
      } else if (moment(day).format("d") === "6") {
        color = "rgba(81, 168, 221, 1.0)";
      };
      let selectRef = null;
      if ((moment(day).format("yyyyMMDD") === moment().format("yyyyMMDD")) ||
          (moment(day).format("yyyyMM") !== moment().format("yyyyMM") && moment(day).format("D") === "1")) {
        selectRef = ref;
      };
      if (props.state.gekkan) {
        if (moment(day).format("D") === "1") {
          for (let weekh = 0; weekh <= 6; weekh++) {
            let wdColor = "rgba(0, 0, 0, 0.1)";
            if (weekh === 0) {
              wdColor = "rgba(232, 122, 144, 0.3)";
            } else if (weekh === 6) {
              wdColor = "rgba(81, 168, 221, 0.3)";
            };
            calendar.push(
              <Grid
                item
                key = {"week" + weekh}
                sx = {{p: 0.1}}
                xs = {12 / 7}
              >
                <ListItem
                  sx = {{height: 40, p: 0, borderRadius: 1.2, bgcolor: wdColor}}
                >
                  <ListItemText
                    sx = {{m: "auto", textAlign: "center"}}
                  >
                    {wdArr[weekh]}
                  </ListItemText>
                </ListItem>
              </Grid>
            );
          };
          for (let weekb = 0; weekb < parseInt(moment(day).format("d")); weekb++) {
            calendar.push(
              <Grid
                item
                key = {"blank" + weekb}
                xs = {12 / 7}
              >
              </Grid>
            );
          };
        };
        const dayItems = props.state.data &&
          props.state.data[moment(day).format("D")][props.state.data.stffNo][props.state.pg];
        // 月間: 時間あり予定があればその開始時刻を優先。時間なしその他のみの日は「その他」
        const primaryTimed = dayItems && dayItems.find((d) =>
          !Boolean(parseInt(d.ptoStatus)) && !Boolean(d.timelessOtherFg)
        );
        const hasTimelessSchedule = dayItems && dayItems.some((d) =>
          !Boolean(parseInt(d.ptoStatus)) && Boolean(d.timelessOtherFg)
        );
        const monthlyData = primaryTimed || (dayItems && dayItems[0]);
        const monthlyLabel = primaryTimed
          ? (primaryTimed.timef || "--:--")
          : (hasTimelessSchedule ? "その他" : null);
        calendar.push(
          <Grid
            item
            key = {moment(day).format("D")}
            xs = {12 / 7}
          >
            <ListItemButton
              id = {day}
              onClick = {(e) => setOpen([!open[0], moment(e.currentTarget.id)])}
              selected = {moment(day).format("yyyyMMDD") === moment().format("yyyyMMDD")}
              sx = {{height: 80, p: 0, border: "1px solid " + color, borderRadius: 1.2, borderTop: "4px solid " + color}}
            >
              <ListItemText
                primary = {moment(day).format("D")}
                primaryTypographyProps = {{component: "div", sx: {float: "left", width: "100%"}}}
                secondary = {
                  <React.Fragment>
                    {monthlyData &&
                      <Typography
                        color = {!Boolean(parseInt(monthlyData.notAllottableFg)) ? "" : monthlyData.ptoStatus === "1" ? "accentY.main" : "accentM.main"}
                        key = {"data0"}
                      >
                        {monthlyLabel}
                        {monthlyData.ptoStatus === "1" && <CheckCircleOutlineIcon color = "accentY" />}
                        {monthlyData.ptoStatus === "2" && <CheckCircleIcon color = "accentM" />}
                        {dayItems.length > 1 && <MoreHorizIcon />}
                      </Typography>}
                  </React.Fragment>
                }
                secondaryTypographyProps = {{component: "div"}}
                sx = {{mt: 0, mb: "auto", pl: 0.2}}
              >
              </ListItemText>
            </ListItemButton>
          </Grid>
        );
      } else {
        calendar.push(
          <Grid
            item
            key = {moment(day).format("D")}
            xs = {12}
          >
            <ListItemButton
              id = {day}
              onClick = {(e) => setOpen([!open[0], moment(e.currentTarget.id)])}
              selected = {moment(day).format("y") === moment().format("y") && moment(day).format("M") === moment().format("M") && moment(day).format("D") === moment().format("D")}
              sx = {{minHeight: 80, pr: 1, border: "1px solid " + color, borderRadius: 2, borderLeft: "6px solid " + color}}
            >
              <ListItemText
                primary = {moment(day).format("D") + " (" + wdArr[parseInt(moment(day).format("d"))] + ")"}
                primaryTypographyProps = {{component: "div", sx: {float: "left", width: "10vh"}, ref: selectRef}}
                secondary = {
                  <React.Fragment>
                    {props.state.data &&
                    props.state.data[moment(day).format("D")][props.state.data.stffNo][props.state.pg].map((data, i) => (
                      <Box
                        key = {"data" + i}
                      >
                        <Typography
                          color = {!Boolean(parseInt(data.notAllottableFg)) ? "" : data.ptoStatus === "1" ? "accentY.main" : "accentM.main"}
                        >
                          {!Boolean(parseInt(data.ptoStatus)) && (Boolean(data.timelessOtherFg)
                            ? (data.svRnm || "----")
                            : ((data.timef || "--:--") + " ~ " + (data.timet || "--:--")))}
                        </Typography>
                        <Typography
                          color = {!Boolean(parseInt(data.notAllottableFg)) ? "" : data.ptoStatus === "1" ? "accentY.main" : "accentM.main"}
                          sx = {{ml: 4}}
                        >
                          {" (" + (!Boolean(parseInt(data.ptoStatus)) ? data.nm || "----" : data.ptoStatus === "1" ? "休暇申請中" : "休暇") + ")"}
                        </Typography>
                      </Box>
                    ))}
                  </React.Fragment>
                }
                secondaryTypographyProps = {{component: "div", sx: {float: "left", ml: 1}}}
                sx = {{display: "flex", alignItems: "center", m: 0}}
              />
            </ListItemButton>
          </Grid>
        );
      };
    };
    return calendar;
  };

  React.useEffect(() => {
    if (props.state.stopRender) {
      sessionStorage.setItem("schedules_date", props.state.date);
      if (new Date(props.state.date + "-01").toLocaleDateString() !== "Invalid Date") {
        getCalendar({ymdDt: new Date(props.state.date).toLocaleDateString()}).then(response => {
          props.setState({
            ...props.state,
            data: response.data,
            jgCd: !Boolean(props.state.jgCd) ? response.data.jgCd : props.state.jgCd,
            stffNos: !Boolean(props.state.stffNos) ? [response.data.stffNo] : props.state.stffNos,
            stopRender: false});
        }).catch(error => {
          if (Boolean(error.response && error.response.data)) {
            props.setState({...props.state, data: {}, stopRender: true});
            navigate("/", {state: error.response.data.message});
          } else {
            props.setToastState({...props.toastState, message: null, error: true, networkError: true});
          }
        });
      };
    };
    if (!props.state.gekkan) {
      scrollToSelect()
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.state.stopRender, props.state.gekkan]);

  return (!Boolean(props.state.stopRender) ?
    <Grid
      container
      spacing = {0}
      sx = {{p: 2}}
    >
      {setCalendarBody()}
      <Drawer
        anchor = "bottom"
        open = {open[0]}
        PaperProps = {{sx: {height: "100%"}}}
      >
        <DayDrawer
          date = {open[1]}
          setOpen = {setOpen}
          setState = {props.setState}
          setToastState = {props.setToastState}
          state = {props.state}
          toastState = {props.toastState}
        />
      </Drawer>
    </Grid>
  : null);
};
